// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"25c74fb8","155":"91cd41a7","187":"155d4b0f","259":"8fe2157f","320":"b20ca519","361":"584c7819","399":"7cd02805","463":"fde08537","527":"4bf92dff","627":"53afac5a","673":"e935da69","831":"9cb717e4"}[chunkId] + ".chunk.js";
};